(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 1100px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (document.body.classList.contains('qs-menu-open')) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quidsin-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFaq = (root) => {
      if (!root || root.dataset.faqInitialized === 'true') return;
      root.dataset.faqInitialized = 'true';

      const search = root.querySelector('[data-faq-search]');
      const filters = Array.from(root.querySelectorAll('[data-faq-filter]'));
      const groups = Array.from(root.querySelectorAll('[data-faq-group]'));
      const noResults = root.querySelector('[data-faq-no-results]');
      let activeCategory = 'all';

      const applyFilters = () => {
        const query = search ? search.value.trim().toLowerCase() : '';
        let visibleTotal = 0;

        groups.forEach((group) => {
          let visibleInGroup = 0;
          const items = Array.from(group.querySelectorAll('[data-faq-item]'));

          items.forEach((item) => {
            const categoryMatch = activeCategory === 'all' || item.dataset.category === activeCategory;
            const searchText = (item.dataset.search || item.textContent || '').toLowerCase();
            const searchMatch = query === '' || searchText.includes(query);
            const visible = categoryMatch && searchMatch;

            item.hidden = !visible;
            if (visible) visibleInGroup += 1;
          });

          group.hidden = visibleInGroup === 0;
          visibleTotal += visibleInGroup;
        });

        if (noResults) noResults.hidden = visibleTotal !== 0;
      };

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          activeCategory = button.dataset.faqFilter || 'all';

          filters.forEach((filter) => {
            const active = filter === button;
            filter.classList.toggle('is-active', active);
            filter.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          applyFilters();
        });
      });

      if (search) {
        search.addEventListener('input', applyFilters);
      }

      root.addEventListener('toggle', (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;

        root.querySelectorAll('details[open]').forEach((details) => {
          if (details !== opened) details.open = false;
        });
      }, true);

      applyFilters();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-faq-section]').forEach(initFaq);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
